import React, { useState, useEffect, useRef } from "react";
import CourseSearch from "./CourseSearch/CourseSearch";
import "./LandingPage.css";
import { lazy, Suspense } from "react";
import useCheckLogin from "../../Helpers/CustomHooks/CheckLogin";
import { useSelector, useDispatch } from "react-redux";
import { OpenLoginSignUp } from "../../Actions/ToggleSignupA";
import { useAuthContext } from "../../context/authContext.js";
import { useLocationContext } from '../../context/locationContext.js'
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { Button, Box } from "@mui/material";
import HowVLIAddValueBtn from "./HowVLIAddValue/HowVLIAddValue";
import LocationPromptPopup from "./LocationPromptPopup";
import errorYellow from "./Assets/erroryellow.png";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import LocationRedirect from "./LocationRedirect";
import { useInView } from "react-intersection-observer";
import ResetPasswordSettingsPopup from "../InstituteSettings/Components/ResetPasswordPopup/ResetPassword.jsx";
import OtpVerificationSettingsPopup from "../InstituteSettings/Components/ResetPasswordPopup/OtpVerificationPopups.jsx";
import CreateNewPasswordSettingsPopup from "../InstituteSettings/Components/ResetPasswordPopup/CreateNewPasswordPopup.jsx";
import ResetPasswordSettingsSuccessPopup from "../InstituteSettings/Components/ResetPasswordPopup/ResetpasswordSuccess.jsx";

const SearchTiles = lazy(() => import("./SearchTiles/SearchTiles"));
const VehicleType = lazy(() => import("./VehicleType/VehicleType"));
const LicenseTypes = lazy(() => import("./LicenseTypes/LicenseTypes"));
const Footer = lazy(() => import("../../Components/Footer/Footer"));
const Courses = lazy(() => import("./CourseSearch/Courses"));
const PrivacyPolicy = lazy(() => import("../../Components/PrivacyPolicy/PrivacyPolicy"));
const ForgotPassword = lazy(() => import("../../popups/forget-password/ForgotPassword"));
const NewPassword = lazy(() => import("../../popups/newPassword/NewPassword"));
const OtpPopup = lazy(() => import("../../popups/otpPopup/OtpPopup"));
const TermAndConditions = lazy(() => import("../../popups/termsAndConditons/TermAndConditions"));

const LandingPage = ({ children }) => {
  useCheckLogin(false, []);
  const activeValue = sessionStorage.getItem("searchTiles")
  const [activeSection, setActiveSection] = useState(
    activeValue ? activeValue : null
  );
  const [searchCourse, setSearchCourse] = useState("");

  // const [searchTilesRef, showSearchTiles] = useInView();
  // const [vehicleRef, showVehicle] = useInView();
  // const [licenseRef, showLicense] = useInView();
  // const [coursesRef, showCourses] = useInView();

  const { ref: searchTilesRef, inView: showSearchTiles } = useInView({
    triggerOnce: true,
    rootMargin: "300px",
  });
  
  const { ref: vehicleRef, inView: showVehicle } = useInView({
    triggerOnce: true,
    rootMargin: "300px",
  });
  
  const { ref: licenseRef, inView: showLicense } = useInView({
    triggerOnce: true,
    rootMargin: "300px",
  });
  
  const { ref: coursesRef, inView: showCourses } = useInView({
    triggerOnce: true,
    rootMargin: "300px",
  });

  const { forgotPass, setForgotPass, resetPass, terms, otpPopup, privacyPolicy, setPrivacyPolicy } = useAuthContext();
  const { UserInfo } = useSelector((Store) => Store.LoginSignupReducer);
  const { location, setLocation } = useLocationContext(); // Use the context
  const [showLocationPrompt, setShowLocationPrompt] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [requestCount, setRequestCount] = useState(0);
  const locationIntervalRef = useRef(null);
  const [popupShownCount, setPopupShownCount] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const toastIntervalRef = useRef(null);
  
  console.log("searchCourse", searchCourse);

  // Check if location is already set
  const isLocationSet = location?.country || location?.state || location?.city || location?.postalCode;

  useEffect(() => {
    const fetchLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            setPermissionDenied(false);
            setShowLocationPrompt(false);
            setShowToast(false);
  
            // ✅ Clear all intervals
            clearInterval(locationIntervalRef.current);
            clearInterval(toastIntervalRef.current);
            locationIntervalRef.current = null;
            toastIntervalRef.current = null;
  
            const { latitude, longitude } = position.coords;
            try {
              const response = await axios.get(
                `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
              );
              const address = response.data.address || {};
              setLocation({
                country: address.country || "",
                state: address.state || "",
                city: address.city || "",
                postalCode: address.postcode || "",
              });

              const locationData = {
                country: address.country || "",
                state: address.state || "",
                city: address.city || "",
                postalCode: address.postcode || "",
              };
              // ✅ Save to sessionStorage
              sessionStorage.setItem("userLocation", JSON.stringify(locationData));

            } catch (error) {
              console.error("Error fetching location details:", error);
            }
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              setPermissionDenied(true);
              setRequestCount((prev) => prev + 1);
            }
          }
        );
      }
    };
  
    const showLocationPopup = () => {
      if (popupShownCount < 4) {
        setShowLocationPrompt(true);
        setPopupShownCount((prev) => prev + 1);
      }
    };
  
    // ✅ Hide toast after 5 seconds
    const handleToastCycle = () => {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 10000);
    };
  
    // ✅ Initial fetch
    if (!isLocationSet && requestCount <= 3) {
      fetchLocation();
    }
  
    // ✅ Show popup every 10s, max 3 times
    if (!isLocationSet && requestCount >= 3 && popupShownCount <= 4 && !locationIntervalRef.current) {
      locationIntervalRef.current = setInterval(() => {
        showLocationPopup();
      }, 10000);
    }
  
    // ✅ Start toast cycle after popup shown 3 times
    if (!isLocationSet && popupShownCount >= 3 && !toastIntervalRef.current) {
      handleToastCycle();
      toastIntervalRef.current = setInterval(() => {
        handleToastCycle();
      }, 20000);
    }
  
    // ✅ Clear intervals when location is set
    if (isLocationSet) {
      clearInterval(locationIntervalRef.current);
      clearInterval(toastIntervalRef.current);
      locationIntervalRef.current = null;
      toastIntervalRef.current = null;
      setShowLocationPrompt(false);
      setShowToast(false);
    }
  
    return () => {
      clearInterval(locationIntervalRef.current);
      clearInterval(toastIntervalRef.current);
      locationIntervalRef.current = null;
      toastIntervalRef.current = null;
    };
  }, [isLocationSet, requestCount, popupShownCount]);

  const handleClosePrompt = () => {
    setShowLocationPrompt(false); // Hide popup temporarily
  };

  const sectionRef = useRef(null);
  const locationScroll = useLocation();

  useEffect(() => {
    if (locationScroll.hash === "#how-vli-add-value") {
      const section = document.getElementById("how-vli-add-value");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [locationScroll]); // only fires when location changes

  const [resetPasswordshowPopup, setResetPasswordShowPopup] = useState(false);
  const [otpVerificationShowPopup, setOtpVerificationShowPopup] = useState(false);
  const [createNewPasswordShowPopup, setCreateNewPasswordShowPopup] = useState(false);
  const [passwordResetSuccessShowPopup, setPasswordResetSuccessShowPopup] = useState(false);
  const [email, setEmail] = useState("");
  
  return (
    <>

      <Helmet>
        <title>
          Vehicle Learning Innovation | Find Driving Schools & Courses in Ontario
        </title>

        <meta
          name="description"
          content="Compare verified driving schools, courses, and license programs across Ontario. Find the right course and enroll online with Vehicle Learning Innovation."
        />

        <meta
          name="keywords"
          content="driving schools in Ontario, driving courses Ontario, learn to drive Ontario, vehicle learning innovation"
        />

        <link rel="canonical" href="https://vehiclelearning.com/" />
      </Helmet>

      <LocationRedirect />

      {/* {terms ? <Terms /> : null} */}
      <div className="">
        <div className="bgGradient absolute -z-10 h-[745px] w-full rounded-b-[300px]"></div>
        <div className="relative mb-40 flex   w-full flex-col items-center md:mb-10 md:block">
          <picture className="-z-10 hidden overflow-hidden md:block">
            <img
              className="LandingContainerLite relative -top-5 -left-28"
              // src={require("./Assets/LiteLandingContainer.svg").default}
              src="/assets/LandingPage/LiteLandingContainer.svg"
              alt="LiteLandingContainer"
            />
          </picture>

          {/* {showLocationPrompt && (
            <div className="overlay z-[99999]"
            style={{
              position: "fixed",
              top: "30%",
              left: "50%",
              transform: "translateX(-50%)",
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
              width: "300px",
              textAlign: "center",
              zIndex: 99999,
            }}>
              <div className="popup">
                <h4>Location Access Denied</h4>
                <p>To improve accuracy, enable location permissions.</p>
                <p>
                  <strong>Go to browser settings → Site Permissions → Enable Location</strong>
                </p>
                <button onClick={handleClosePrompt}>OK, Got it</button>
              </div>
            </div>
          )} */}
          {showLocationPrompt && popupShownCount < 3 && (
            <LocationPromptPopup
              setShowPopup={setShowLocationPrompt}
            />
          )}

          {showToast && (
              <div className="fixed flex items-center gap-[10px] bottom-5 right-5 z-[9999] px-6 py-2 rounded-lg 
              bg-[linear-gradient(90deg,_#FFFFFF_0%,_#DFE0FF_28%,_#D7D9FF_100%)] bg-no-repeat text-[#000000] text-[16px] shadow-[0_0_8px_#00000029] rounded-[4px] animate-fade-in-out
              max-w-[450px] 2.5xl:max-w-[550px] whitespace-pre-wrap break-words"
              style={{border:"1px solid #DCDCDC"}}>
                  <img className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                      src={errorYellow} 
                      alt="Error-Icon"
                  /> 
                  Location access denied, please enable location
              </div>
          )}

          <div className="h- -top-0 w-full rounded-b-[300px] md:absolute md:h-auto md:min-h-fit md:rounded-[0px] md:bg-[#291c5f00] xl:w-full ">
            {UserInfo?.UserName ? null : <LoginRegister />}
            <picture className=" ">
              <source
                media="(max-width:635px)"
                className=""
                srcSet={require("./Assets/Rectangle.svg").default}
              />

              <source
                media="(min-width:768px)"
                srcSet={require("./Assets/LandingContainer.svg").default}
              />
              <img
                className="hidden w-full md:inline-block"
                loading="eager"
                fetchpriority="high"
                // src={require("./Assets/LandingContainer.svg").default}
                src="/assets/LandingPage/LandingContainer.svg"
                alt="Driving-License-Tab-Image"
              />
            </picture>
          </div>
          
          <div className="top-32  left-0 mt-[150px] flex w-full flex-col items-center justify-around md:absolute md:top-[3rem] md:mt-0 md:flex-row">
            <div className=" mx-1 flex w-[80%]  md:w-[65%] lg:w-[55%] xl:w-[47%] flex-col gap-10 sm:-top-0 md:relative  md:left-6 md:z-10 md:m-0   md:gap-1 md:px-10 md:pb-4 lg:gap-[0px] lg:pb-4  xl:pb-1 ">
              <h1 className="LandingPagetext text-pretty text-center py-0 m-0  text-white md:w-auto  text-2xs xl:text-sm md:text-left  2xl:text-lg lg:mt-[70px]">
                  Welcome to Vehicle Learning Innovation. Connecting Learners with Certified Training Institutes for a Seamless Licensing Journey
              </h1>
              
              <h2 className="Regularfont text-pretty text-center py-0 m-0  font-thin text-white md:text-left text-4xs xl:text-2xs   2xl:text-sm lg:mt-[15px] ">
                At Vehicle Learning innovation, we bridge the gap between aspiring learner and professional training institutes.
              </h2>
              <h2 className="Regularfont text-pretty text-center py-0 m-0   font-thin text-white md:text-left text-4xs xl:text-2xs   2xl:text-sm ">
                Whether you're a learner eager to obtain your license or an institute aiming to expand your reach, our platform offers tailored solutions to meet your needs.
              </h2>
            </div>
            <div className="flex w-[70%] md:w-[35%] lg:w-[45%] xl:w-[50%]">
              <div className="relative w-full">
                {/* <img
                  className=" mt-4 w-full md:mt-0 relative lg:top-[9rem] lg:right-[1rem] 4xl:top-[7rem] 4xl:right-[3rem] aspect-[16/9]"
                  src="/assets/LandingPage/LandingHeroSVG.svg"
                  // src={LandingHeroImage}
                  alt="Driving-License-Image"
                  loading="eager"
                  fetchpriority="high"
                /> */}
                <picture>
                  <source
                    srcSet="/assets/LandingPage/LandingHeroImage.webp"
                    type="image/webp"
                  />
                  <img
                    src="/assets/LandingPage/LandingHeroSVG.svg"
                    alt="Driving-License-Image"
                    width="800"
                    height="450"
                    className="mt-4 w-full md:mt-0 relative lg:top-[9rem] lg:right-[1rem]"
                    loading="eager"
                    fetchpriority="high"
                  />
                </picture> 
              </div>
            </div>
          </div>
        </div>

        
        <Suspense fallback={null}>

            <div id="how-vli-add-value" ref={sectionRef}>
              <HowVLIAddValueBtn autoOpen={locationScroll.hash === "#how-vli-add-value"}  />
            </div>

            {terms ? <TermAndConditions /> : null}
            {privacyPolicy ? <PrivacyPolicy setShowPrivacyPolicyPopup={setPrivacyPolicy} /> : null }
            {/* {forgotPass && <ForgotPassword />} */}
            {forgotPass && <ResetPasswordSettingsPopup
                setResetPasswordShowPopup={setForgotPass}
                email={email}
                setEmail={setEmail}
                setOtpVerificationShowPopup={setOtpVerificationShowPopup} 
            />}

            {otpVerificationShowPopup && (
                <OtpVerificationSettingsPopup
                    userEmail={email}
                    setOtpVerificationShowPopup={setOtpVerificationShowPopup}
                    setCreateNewPasswordShowPopup={setCreateNewPasswordShowPopup}
                />
            )}
            
            {createNewPasswordShowPopup && (
                <CreateNewPasswordSettingsPopup
                setCreateNewPasswordShowPopup={setCreateNewPasswordShowPopup}
                setPasswordResetSuccessShowPopup={setPasswordResetSuccessShowPopup}
                // UserId={UserId}
                userEmail={email}
                />
            )}

            {passwordResetSuccessShowPopup && (
                <ResetPasswordSettingsSuccessPopup
                    setPasswordResetSuccessShowPopup={setPasswordResetSuccessShowPopup}
                    isLandingPage={true}   // pass this only on the landing page usage
                />
            )}


            {otpPopup ? <OtpPopup /> : null}
            {resetPass ? <NewPassword /> : null}

            <div ref={searchTilesRef}>
              {showSearchTiles && (
                <SearchTiles
                  activeSection={activeSection}
                  setActiveSection={setActiveSection}
                />
              )}
            </div>

            <div ref={vehicleRef }>
                {showVehicle && activeSection === "vehicle" && <VehicleType />}
            </div>

            <div ref={licenseRef}>
                {showLicense && activeSection === "license" && <LicenseTypes />}
            </div>

            <div ref={coursesRef}>
            {showCourses  && activeSection === "courses" && (
              <>
                <CourseSearch
                  setSearchCourse={setSearchCourse}
                  searchCourse={searchCourse}
                />
                <Courses searchCourse={searchCourse} />
              </>
            )}
            </div>

            <Footer FooterBgColor="#F1FAFF" />
        </Suspense>

      </div>
    </>
  );
};

function LoginRegister() {
  const Dispatch = useDispatch();

  return (
    <nav
      id="RegisterPortion"
      className="absolute right-4 top-[105px] z-20 hidden w-auto items-center justify-center gap-[12px] lg:flex"
    >
        {/* <Link
          onClick={() => Dispatch(OpenLoginSignUp("Sign In", true))}
        >
          <TextField
              variant="outlined"
              // defaultValue="Login\Register"
              label="Student"
              InputLabelProps={{
                sx: {
                  color: "white", // Label color white
                  fontSize: "18px", // Label font size
                },
              }}
              InputProps={{
                sx: {
                  color: "white",
                  fontSize: "18px",
                  borderColor: "#EA52C6",
                  borderRadius: "21px", // Rounded border
                  cursor: "pointer", // Pointer cursor for the whole field
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EA52C6",
                    borderWidth: "2px", // Set border thickness to 2px
                    borderRadius: "21px", // Rounded border
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EA52C6",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EA52C6",
                  },
                  height: "50px",
                  width: "150px",
                  "& input": {
                    paddingInline: "15px", // Correct way to apply padding to the input field
                    cursor: "pointer", // Ensure pointer cursor inside input field
                  },
                },
              }}
              size="small"
            >Login\Register</TextField>
        </Link> */}

        <TextField
          variant="outlined"
          label="Learner"
          InputLabelProps={{
            sx: {
              color: "white",
              fontSize: "18px",
            },
          }}
          InputProps={{
            sx: {
              borderRadius: "15px",
              cursor: "pointer",
              height: "50px",
              width:"180px",
              display: "flex",
              alignItems: "center",
              paddingBox:"10px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6 !important", // Ensures border color applies
                borderWidth: "2px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
            },
            startAdornment: (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Sign In", true, "", "Student"))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Login
                </Button>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    paddingInline: "5px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Register
                </Button>
              </Box>
            ),
          }}
        />

      <TextField
          variant="outlined"
          label="Partner"
          InputLabelProps={{
            sx: {
              color: "white",
              fontSize: "18px",
            },
          }}
          InputProps={{
            sx: {
              borderRadius: "15px",
              cursor: "pointer",
              height: "50px",
              width:"170px",
              display: "flex",
              alignItems: "center",
              paddingBox:"10px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6 !important", // Ensures border color applies
                borderWidth: "2px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EA52C6",
              },
            },
            startAdornment: (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Sign In", true, "Partner", "Institute"))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    paddingInline: "5px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Login
                </Button>
                <Button
                  onClick={() => Dispatch(OpenLoginSignUp("Register", true, "Partner"))}
                  variant="contained"
                  sx={{
                    backgroundColor: "#EA52C691",
                    color: "white",
                    borderRadius: "9px",
                    fontSize: "16px",
                    height: "30px",
                    paddingInline: "5px",
                    textTransform: "none", // Prevents automatic capitalization
                    "&:hover": {
                      backgroundColor: "#EA52C6",
                    },
                  }}
                >
                  Register
                </Button>
              </Box>
            ),
          }}
        />

        {/* <Link
          onClick={() => Dispatch(OpenLoginSignUp("Register", true))}
        >
          <TextField
            variant="outlined"
            defaultValue="Login\Register"
            label="Partner"
            InputLabelProps={{
              sx: {
                color: "white", // Label color white
                fontSize: "18px", // Label font size
              },
            }}
            InputProps={{
              sx: {
                color: "white",
                fontSize: "18px",
                borderColor: "#EA52C6",
                borderRadius: "21px", // Rounded border
                cursor: "pointer", // Pointer cursor for the whole field
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EA52C6",
                  borderWidth: "2px", // Set border thickness to 2px
                  borderRadius: "21px", // Rounded border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EA52C6",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#EA52C6",
                },
                height: "50px",
                width: "150px",
                "& input": {
                  paddingInline: "15px", // Correct way to apply padding to the input field
                  cursor: "pointer", // Ensure pointer cursor inside input field
                },
              },
            }}
            size="small"
          />
        </Link> */}
        {/* <Link
          className="Regularfont  text-xs text-white no-underline xl:text-2xs"
          onClick={() => Dispatch(OpenLoginSignUp("Sign In", true))}
        >
          Login
        </Link>
        <Link
          className={`Regularfont rounded-[25px] bg-[#EA52C6] text-center text-xs text-white
                                    no-underline     lg:py-3         lg:px-7
                                    xl:py-4     xl:px-10        xl:text-2xs 
                        2xl:py-5                 2xl:px-12       `}
          onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
        >
          Register
        </Link> */}
    </nav>
  );
}
export default LandingPage;
